import { LicenseScopeRequestField } from 'projects/shared/src/lib/authentication/license-scope';

export type LicenseScopeApi = 'gateway' | 'main' | 'workflow';
export type LicenseScopeHttpMethod = 'GET' | 'POST';
export type LicenseScopeBodyPathSegment = string | '[]';

export interface ILicenseScopeBodyTarget {
  readonly field: LicenseScopeRequestField;
  readonly path: readonly LicenseScopeBodyPathSegment[];
}

export interface ILicenseScopeEndpointRule {
  readonly api: LicenseScopeApi;
  readonly method: LicenseScopeHttpMethod;
  readonly path: string;
  readonly queryFields: readonly LicenseScopeRequestField[];
  readonly bodyFields: readonly LicenseScopeRequestField[];
  readonly bodyTargets?: readonly ILicenseScopeBodyTarget[];
}

/**
 * Generated from the refreshed Gateway, Main Service, and Workflow OpenAPI contracts.
 * Master Company, Broker, and Loss Adjuster creation endpoints are deliberately excluded
 * because their code fields identify the new entity rather than the logged-in owner.
 */
export const LICENSE_SCOPE_ENDPOINT_RULES = [
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/broker/credit',
    queryFields: [],
    bodyFields: ['brokerCode', 'companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/broker/credit/search',
    queryFields: ['brokerCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/broker/loss-adjuster/fee',
    queryFields: [],
    bodyFields: ['lossAdjusterCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/broker/loss-adjuster/search',
    queryFields: ['adjusterCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/broker/outstanding/credit-note',
    queryFields: ['brokerCode', 'companyCode'],
    bodyFields: [],
  },
  { api: 'gateway', method: 'GET', path: '/v1/broker/search', queryFields: ['brokerCode'], bodyFields: [] },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/broker/validate/license/{brokerCode}',
    queryFields: ['brokerCode'],
    bodyFields: [],
  },
  { api: 'gateway', method: 'POST', path: '/v1/claim', queryFields: [], bodyFields: ['companyCode'] },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/claim/analytics',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  { api: 'gateway', method: 'POST', path: '/v1/claim/health', queryFields: [], bodyFields: ['licenseCode'] },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/claim/health/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/claim/reinsurance',
    queryFields: [],
    bodyFields: ['companyCode', 'licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/claim/reinsurance/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  { api: 'gateway', method: 'GET', path: '/v1/claim/search', queryFields: ['companyCode'], bodyFields: [] },
  { api: 'gateway', method: 'GET', path: '/v1/claim/summary', queryFields: ['company'], bodyFields: [] },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/claim/triangle-gross-acc-rep',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/claim/triangle-gross-acc-rep/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/claim/triangle-gross-acc-set',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/claim/triangle-gross-acc-set/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/claim/triangle-gross-rep-set',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/claim/triangle-gross-rep-set/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/claim/triangle-net-acc-rep',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/claim/triangle-net-acc-rep/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/claim/triangle-net-acc-set',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/claim/triangle-net-acc-set/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/claim/triangle-net-rep-set',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/claim/triangle-net-rep-set/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/client/analytics',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/client/fraud/search',
    queryFields: ['company'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/client/provider/discipline/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/client/sector/analytics',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/event/logs/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/account',
    queryFields: [],
    bodyFields: ['licenseCategory', 'licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/account/brown-card-payment/validate',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/account/search',
    queryFields: ['licenseCategory', 'licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/biodata-validation/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/ecowas/account',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/ecowas/account-analysis',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/expenses',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/expenses/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/expenses/analysis',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/liability',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/liability/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/orsa',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/orsa/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/orsa/feed',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/orsa/feed/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/orsa/ratios',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/orsa/ratios/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/prepayment',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/prepayment-details',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/prepayment-details/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/prepayment/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  { api: 'gateway', method: 'POST', path: '/v1/finance/rbc', queryFields: [], bodyFields: ['licenseCode'] },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/rbc/feed/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/rbc/risk-details',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/rbc/risk-details/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/rbc/risk-groups',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/rbc/risk-groups/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/rbc/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/rbc/setup/compute-risk-diversification',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/valuation',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/valuation/product',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/valuation/product/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/valuation/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/valuation/triangle',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/finance/valuation/triangle/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  { api: 'gateway', method: 'POST', path: '/v1/hris/employee', queryFields: [], bodyFields: ['licenseCode'] },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/hris/employee/multiple',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/hris/employee/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/coinsurance',
    queryFields: [],
    bodyFields: ['licenseCat', 'licenseCode'],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/accreditation',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/accreditation/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/accreditation/suspense',
    queryFields: [],
    bodyFields: ['licenseCategory', 'licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/accreditation/suspense/search',
    queryFields: ['licenseCategory', 'licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/bank/account',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/bank/account/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/board',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/board-committee',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/board-committee/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/board/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/branch',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/branch/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/department-heads',
    queryFields: [],
    bodyFields: ['licenseCat', 'licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/department-heads/search',
    queryFields: ['licenseCat', 'licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/inspection/history',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/inspection/history/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/regulator/inspections',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/regulator/inspections/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/key-officer/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/message',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/message/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/officer',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/officer/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/rating',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/rating/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/senior-executive',
    queryFields: [],
    bodyFields: ['licenseCat', 'licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/senior-executive/search',
    queryFields: ['licenseCat', 'licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/shareholder',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/shareholder/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/staff-fraud',
    queryFields: [],
    bodyFields: ['licenseCat', 'licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/staff-fraud/search',
    queryFields: ['licenseCat', 'licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/statutory/role',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/statutory/role/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/subsidiary',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/subsidiary/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/company/training',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/company/training/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/onboarding/infraction',
    queryFields: [],
    bodyFields: ['licenseCat', 'licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/infraction/analytics',
    queryFields: ['licenseCategory', 'licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/onboarding/infraction/search',
    queryFields: ['licenseCat', 'licenseCode'],
    bodyFields: [],
  },
  { api: 'gateway', method: 'POST', path: '/v1/policy', queryFields: [], bodyFields: ['companyCode'] },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/accounts-reg-levy',
    queryFields: [],
    bodyFields: ['licenseCategory', 'licenseCode'],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/accounts-reg-levy-details',
    queryFields: [],
    bodyFields: ['licenseCategory', 'licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/accounts-reg-levy-details/search',
    queryFields: ['licenseCategory', 'licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/accounts-reg-levy/search',
    queryFields: ['licenseCategory', 'licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/accounts/fire-fund-details',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/accounts/fire-fund-details/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/accounts/fire-fund-levy',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/accounts/fire-fund-levy/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/accounts/ppf',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/accounts/ppf-details',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/accounts/ppf-details/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/accounts/ppf/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/analytics',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/bond/summary',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/commission',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/commission/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/compulsory-insurance/analytics',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/exposure/report',
    queryFields: ['company'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/group-sector/analytics',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/rank/data',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/receipt',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/receipt/analytics',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/receipt/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/reinsurance',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/reinsurance/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  { api: 'gateway', method: 'GET', path: '/v1/policy/search', queryFields: ['companyCode'], bodyFields: [] },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/policy/validate/reg-policyno',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/advert/license',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/company/investments',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/company/return/future',
    queryFields: [],
    bodyFields: ['licenseCat', 'licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/company/return/future/search',
    queryFields: ['companyCode', 'licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/company/return/future/summary',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/investment',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/investment/limit',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/investment/limit/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/investment/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/license',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/license-health',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/license-health/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/license/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/reinsurance/aip',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/reinsurance/aip/company',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/reinsurance/aip/company/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/reinsurance/aip/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/reinsurance/license',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/reinsurance/license/company',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/reinsurance/license/company/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/reinsurance/license/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/treaty',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/treaty/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/takaful/results',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v1/product/takaful/results/search',
    queryFields: ['licenseCode'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v2/policy/annuity/new-business',
    queryFields: ['company'],
    bodyFields: [],
  },
  {
    api: 'gateway',
    method: 'GET',
    path: '/v2/policy/motor/new-business',
    queryFields: ['company'],
    bodyFields: [],
  },
  { api: 'main', method: 'GET', path: '/v1/agent/company/summary', queryFields: ['company'], bodyFields: [] },
  { api: 'main', method: 'POST', path: '/v1/agent/fraud', queryFields: [], bodyFields: ['company'] },
  { api: 'main', method: 'GET', path: '/v1/agent/fraud/search', queryFields: ['company'], bodyFields: [] },
  { api: 'main', method: 'POST', path: '/v1/agent/legacy/license', queryFields: [], bodyFields: ['company'] },
  { api: 'main', method: 'POST', path: '/v1/cifm/candidates', queryFields: [], bodyFields: ['company'] },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/cifm/candidates/search',
    queryFields: ['company'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'POST',
    path: '/v1/cifm/candidates/signup',
    queryFields: [],
    bodyFields: ['company'],
  },
  { api: 'main', method: 'POST', path: '/v1/company/account', queryFields: [], bodyFields: ['company'] },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/company/account/cifm/rrr/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'POST',
    path: '/v1/company/account/details',
    queryFields: [],
    bodyFields: ['company'],
  },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/company/account/details/search',
    queryFields: ['company'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'POST',
    path: '/v1/company/account/payment',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'POST',
    path: '/v1/company/account/remitta-retrieval-reference',
    queryFields: [],
    bodyFields: ['company'],
  },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/company/account/remitta-retrieval-reference/search',
    queryFields: ['company'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/company/account/search',
    queryFields: ['company'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'POST',
    path: '/v1/company/agent/account',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  { api: 'main', method: 'GET', path: '/v1/company/api-keys', queryFields: ['companyCode'], bodyFields: [] },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/company/api-keys/secret/regenerate',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/company/arian/account/details/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'POST',
    path: '/v1/company/arian/account/payment',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'POST',
    path: '/v1/company/arian/account/rrr',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/company/arian/account/rrr/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/company/arian/account/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/company/balance/payable',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'POST',
    path: '/v1/company/cifm/account/payment',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  { api: 'main', method: 'GET', path: '/v1/company/search', queryFields: ['companyCode'], bodyFields: [] },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/company/summarize/accounts/details',
    queryFields: ['company'],
    bodyFields: [],
  },
  { api: 'main', method: 'GET', path: '/v1/company/validate', queryFields: ['companyCode'], bodyFields: [] },
  { api: 'main', method: 'GET', path: '/v1/document/mapping', queryFields: ['company'], bodyFields: [] },
  { api: 'main', method: 'POST', path: '/v1/document/mapping', queryFields: [], bodyFields: ['company'] },
  { api: 'main', method: 'GET', path: '/v1/document/search', queryFields: ['company'], bodyFields: [] },
  {
    api: 'main',
    method: 'POST',
    path: '/v1/document/sensitivity',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/document/sensitivity/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  { api: 'main', method: 'GET', path: '/v1/policy/fraud/search', queryFields: ['company'], bodyFields: [] },
  { api: 'main', method: 'POST', path: '/v1/setup/agent-type', queryFields: [], bodyFields: ['company'] },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/setup/agent-type/search',
    queryFields: ['company'],
    bodyFields: [],
  },
  {
    api: 'main',
    method: 'GET',
    path: '/v1/users/activity/log/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  { api: 'main', method: 'POST', path: '/v1/users/group', queryFields: [], bodyFields: ['company'] },
  { api: 'main', method: 'GET', path: '/v1/users/search', queryFields: ['company'], bodyFields: [] },
  {
    api: 'main',
    method: 'POST',
    path: '/v1/users/signup',
    queryFields: [],
    bodyFields: ['brokerCode', 'company', 'licenseCat', 'licenseCode'],
  },
  {
    api: 'main',
    method: 'POST',
    path: '/v2/agent/legacy/license/{requestId}',
    queryFields: [],
    bodyFields: ['company'],
  },
  {
    api: 'main',
    method: 'POST',
    path: '/v2/cifm/candidates/signup',
    queryFields: [],
    bodyFields: ['company'],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/appraisal/coy/setup',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/appraisal/coy/setup',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/appraisal/coy/setup/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/appraisal/criteria/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/appraisal/criteria/setup',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/appraisal/division/setup',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/appraisal/individual/setup',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/appraisal/setup/div/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/appraisal/setup/ind/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/appraisal/setup/subdiv/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/appraisal/setup/team/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/appraisal/subdivision/setup',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/workflow/application',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/workflow/application-setup',
    queryFields: [],
    bodyFields: ['licensedCode'],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/workflow/application/product',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/workflow/application/rule',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/workflow/application/rule/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/workflow/application/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/workflow/application/setup/stages',
    queryFields: [],
    bodyFields: ['licenseCode'],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/workflow/future',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/workflow/generate',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/workflow/schedule',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/workflow/schedule/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/workflow/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/workflow/task',
    queryFields: [],
    bodyFields: ['companyCode'],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/workflow/task-process/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/workflow/task/company/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  {
    api: 'workflow',
    method: 'GET',
    path: '/v1/workflow/task/search',
    queryFields: ['companyCode'],
    bodyFields: [],
  },
  // Nested request envelopes discovered in the refreshed OpenAPI request-body schemas.
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/broker/loss-adjuster/bulk/{requestId}',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'adjusterCode', path: ['data', '[]', 'adjusterCode'] }],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/claim/bulk/reinsurance/{requestId}',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'companyCode', path: ['data', '[]', 'companyCode'] }],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/claim/bulk/{requestId}',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'companyCode', path: ['data', '[]', 'companyCode'] }],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/claim/health/bulk/{requestId}',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'licenseCode', path: ['data', '[]', 'licenseCode'] }],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/finance/bulk/{requestId}',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'licenseCode', path: ['data', '[]', 'expenses', 'licenseCode'] }],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/bulk',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'companyCode', path: ['policy', 'companyCode'] }],
  },
  ...['annuity', 'aviation', 'basic', 'bond', 'building', 'marine-cargo', 'marine-hull', 'motor'].map(
    (policyType) => ({
      api: 'gateway' as const,
      method: 'POST' as const,
      path: `/v1/policy/bulk/${policyType}/{requestId}`,
      queryFields: [],
      bodyFields: [],
      bodyTargets: [{ field: 'companyCode' as const, path: ['data', '[]', 'policy', 'companyCode'] }],
    }),
  ),
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/bulk/commission/{requestId}',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'companyCode', path: ['data', '[]', 'policyCommission', 'companyCode'] }],
  },
  ...['group-life', 'group-motor'].map((policyType) => ({
    api: 'gateway' as const,
    method: 'POST' as const,
    path: `/v1/policy/bulk/${policyType}`,
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'companyCode' as const, path: ['policy', 'companyCode'] }],
  })),
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/policy/bulk/receipt/{requestId}',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'companyCode', path: ['data', '[]', 'companyCode'] }],
  },
  {
    api: 'gateway',
    method: 'POST',
    path: '/v1/product/bulk/license/migration/{requestId}',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'companyCode', path: ['data', '[]', 'companyCode'] }],
  },
  ...[
    'annuity',
    'aviation',
    'basic',
    'building',
    'general-accident',
    'group-life',
    'marine-cargo',
    'marine-hull',
  ].map((policyType) => ({
    api: 'gateway' as const,
    method: 'POST' as const,
    path: `/v2/policy/bulk/${policyType}`,
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'companyCode' as const, path: ['policy', 'companyCode'] }],
  })),
  ...['bond', 'motor'].map((policyType) => ({
    api: 'gateway' as const,
    method: 'POST' as const,
    path: `/v2/policy/bulk/${policyType}/{requestId}`,
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'companyCode' as const, path: ['data', '[]', 'policy', 'companyCode'] }],
  })),
  {
    api: 'gateway',
    method: 'POST',
    path: '/v2/policy/bulk/receipt/{requestId}',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'companyCode', path: ['data', '[]', 'companyCode'] }],
  },
  {
    api: 'main',
    method: 'POST',
    path: '/v1/users/bulk/validation',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'company', path: ['validateBulkUsersList', '[]', 'company'] }],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/appraisal/team/setup',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'companyCode', path: ['appraisalSetupTeam', 'companyCode'] }],
  },
  {
    api: 'workflow',
    method: 'POST',
    path: '/v1/workflow/task-process',
    queryFields: [],
    bodyFields: [],
    bodyTargets: [{ field: 'companyCode', path: ['workflowTaskProcess', 'companyCode'] }],
  },
] as const satisfies readonly ILicenseScopeEndpointRule[];
